var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtisanV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0769 12.9756H27.5612C27.5612 12.9756 40.2987 14.5958 40.2987 30.1504C40.2987 45.705 22.7536 45.3699 22.7536 45.3699L22.0769 12.9756Z",
    fill: "#00558F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4158 45.3705C29.9572 45.3705 36.0692 38.5836 36.0692 30.2131C36.0692 21.8425 29.9572 15.0537 22.4158 15.0537C14.8744 15.0537 8.76245 21.8406 8.76245 30.2131C8.76245 38.5855 14.8763 45.3705 22.4158 45.3705Z",
    fill: "#0080D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60815 29.7627H44.1842C44.1842 29.7627 44.3621 27.1825 42.3981 26.8508C42.3981 26.8508 43.2222 14.9672 33.8722 9.56054H31.9102V6.40242C31.9102 6.40242 31.7062 4.18848 30.3102 4.18848H19.4662C19.4662 4.18848 17.9402 4.50184 17.9402 6.26811V9.56054H15.8802C15.8802 9.56054 7.34417 13.3698 7.34417 26.6901C7.34417 26.6901 5.60815 27.4186 5.60815 29.7627Z",
    fill: "#FBA03D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8121 9.56055H15.8801V24.4294H17.8121V9.56055Z",
    fill: "#FDB86D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8821 4.20678C23.8821 4.20678 25.1481 4.80504 25.1481 6.26811V24.4294H26.9981V9.56054H31.9081V6.40242C31.9081 6.40242 31.8661 4.18848 30.3081 4.18848C28.7501 4.18848 23.8801 4.20678 23.8801 4.20678H23.8821Z",
    fill: "#FDB86D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7741 26.8244C35.7741 26.8244 37.6781 27.0788 37.6781 29.7628H44.3861C44.3861 29.7628 44.5901 26.8508 42.6001 26.8508C42.6001 26.8508 42.6981 13.787 34.0741 9.56055H27.2041C27.2041 9.56055 36.0021 13.787 35.7741 26.8244Z",
    fill: "#FB861B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtisanV2);
export default __webpack_public_path__ + "static/media/artisan-v2.6d193f08659610e26837d8d758ff25d4.svg";
export { ForwardRef as ReactComponent };